module.exports = __webpack_public_path__ + "img/left-to-line.d23a9acd.svg";